export default __webpack_public_path__ + "static/banner-71f09978c03807d254cb23d1719cf426.svg";